"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.StuffAssetSearchResult = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var use_on_click_index_1 = require("@hiyllo/ux/use-on-click-index");
var common_1 = require("../common");
var keyboard_hint_1 = require("../keyboard-hint");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var omni_continuity_1 = require("@hiyllo/omni-continuity");
var features_1 = require("@hiyllo/omni-common/src/types/navigation/features");
var platform_1 = require("@hiyllo/ux/platform");
var react_native_1 = require("react-native");
exports.StuffAssetSearchResult = react_1["default"].memo(function StuffAssetSearchResult(props) {
    var FontAwesomeIcon = (0, platform_1.useFontAwesomeIcon)();
    var nav = (0, omni_continuity_1.useNavigate)();
    var onClick = react_1["default"].useCallback(function () {
        nav(props.result.asset.type === 'document'
            ? {
                feature: features_1.Features.stuff,
                params: {
                    view: 'document',
                    uuid: props.result.asset.uuid
                }
            }
            : props.result.asset.type === 'form'
                ? {
                    feature: features_1.Features.forms,
                    params: {
                        view: 'edit',
                        formUUID: props.result.asset.uuid
                    }
                }
                : props.result.asset.type === 'meeting-recording'
                    ? {
                        feature: features_1.Features.stuff,
                        params: {
                            view: 'meeting-recording',
                            uuid: props.result.asset.uuid
                        }
                    }
                    : {
                        feature: features_1.Features.stuff,
                        params: {
                            view: 'container',
                            uuid: props.result.asset.parent
                        }
                    });
        props.onClose();
    }, [nav, props]);
    (0, use_on_click_index_1.useOnClickIndex)(onClick, props.index);
    return ((0, jsx_runtime_1.jsxs)(common_1.SearchResultContainer, __assign({ onPress: onClick }, { children: [(0, jsx_runtime_1.jsx)(keyboard_hint_1.SearchResultKeyboardHint, { showTabHint: true, value: (props.index + 1).toString() }), props.result.asset.type === 'file' &&
                (props.result.asset.src.includes('.png') ||
                    props.result.asset.src.includes('.jpg') ||
                    props.result.asset.src.includes('.jpeg')) ? ((0, jsx_runtime_1.jsx)("img", { src: props.result.asset.src, style: {
                    height: 30,
                    width: 30,
                    objectFit: 'contain'
                } })) : ((0, jsx_runtime_1.jsx)(FontAwesomeIcon, { icon: pro_light_svg_icons_1.faFile, color: "white" })), (0, jsx_runtime_1.jsx)(common_1.SearchResultText, { children: props.result.asset.name }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { width: 15 } }), (0, jsx_runtime_1.jsx)(common_1.SearchResultAppLabel, { icon: pro_light_svg_icons_1.faFile, title: "Asset" })] })));
});
